module.exports = __webpack_public_path__ + "img/w33.c9cbcec4.svg";